import React, { useEffect, useContext, useState, useRef } from "react";
import { DocumentDetailContext } from "pages/DocumentDetail/contexts/DocumentDetailContext";
import { Edit } from "@mui/icons-material";
import { TextField } from "@mui/material";


const FlagNotes = (props) => {
    const { setDocumentData, data = {}, duplicateDocumentView, setDialogs, setDataSave } = useContext(DocumentDetailContext);
    const [showTextBox, setShowTextBox] = useState(false);
    const [inputText, setInputText] = useState(data?.Entity_Details?.notes || "");
    const flagNotesRef = useRef(null);

    useEffect(() => {
        let temp = { ...data };
        temp.Entity_Details.notes = inputText;
        setDocumentData({ ...temp });
    }, [inputText]);

    useEffect(() => {
        setInputText(data?.Entity_Details?.notes || "");
    }, [data?.Entity_Details?.notes]);

    useEffect(() => {
        function handleOutsideClick(event) {
            if (flagNotesRef.current && !flagNotesRef.current.contains(event.target)) {
                setShowTextBox(false)
            }
        }
        document.addEventListener("click", handleOutsideClick);
        return () => document.removeEventListener("click", handleOutsideClick);
    }, []);

    const handleChange = (e) => {
        setInputText(e.target.value);
        setDataSave(true);
    }

    const validateFlagNotes = () => {
        const { Tags = [] } = data || {};
        let flag = false;
        Tags.forEach(m => {
            if (m.tag_display_name == "SPAM" && m.enabled) {
                flag = true;
            }
        });
        if (flag && inputText?.trim() && !(inputText?.match(/^(\+\d{1,2}\s)?(\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4}$/i))) {
            setDialogs(prevState => ({
                ...prevState,
                spamFaxNumberValidation: true
            }));
        }
    }

    return <div className="notes-section" ref={flagNotesRef}>
        <div className="icon-text" style={{ width: "max-content" }}>
            <div className="notes-label">Flag Notes</div>
            {<Edit
                fontSize="small"
                className={!duplicateDocumentView ? "icon-review-style" : "icon-remove-style"}
                onClick={() => {
                    if (!duplicateDocumentView) {
                        setShowTextBox(true);
                    }

                }} />}
        </div>
        {showTextBox ?
            <TextField
                name="free_text"
                value={inputText}
                onChange={handleChange}
                id="outlined-textarea"
                rows={2}
                multiline
                onBlur={validateFlagNotes}
                sx={{
                    width: 200,
                    "> div": {
                        padding: "5px 10px"
                    }
                }}
            />
            :
            <div style={{ textAlign: "left" }}>{data.Entity_Details?.notes}</div>}
    </div>
}

export default FlagNotes;